import { sendCommand as sendCommandToAPI } from "./openapi/api-client.ts";

export interface BaseCommand {
  command: string;
}

export interface CompetitionCommand {
  command: "competition";
  competitionId: string;
}

export interface LedwallDisable {
  command: "ledwall.disable";
}

export interface LedwallEnable {
  command: "ledwall.enable";
}

export interface LedwallActivityItemSelect {
  command: "ledwall.activityItem.select";
  activityItemId: string;
}

export interface LedwallActivityItemDisable {
  command: "ledwall.activityItem.disable";
}

export interface LedwallDimSpotSet {
  command: "ledwall.dimSpot.set";
  x: number; // 0-1 relative position
  y: number; // 0-1 relative position
}

export interface LedwallDimSpotClear {
  command: "ledwall.dimSpot.clear";
}

export interface CommentatorOn {
  command: "commentator.on";
}

export interface CommentatorOff {
  command: "commentator.off";
}

export interface HornCommand {
  command: "horn";
}

export type Command =
  | CompetitionCommand
  | LedwallDisable
  | LedwallEnable
  | LedwallActivityItemSelect
  | LedwallActivityItemDisable
  | LedwallDimSpotSet
  | LedwallDimSpotClear
  | CommentatorOff
  | CommentatorOn
  | HornCommand;

export const sendCommand = async (command: Command) => {
  await sendCommandToAPI({ ...command, tags: [] });
};
